import dotProp from 'dot-prop-immutable';
import { mapObjIndexed, forEachObjIndexed } from 'ramda';
// ------------------------------------
// Constants
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

const translationfunc = (handlers, name, value) => {
  const handler = handlers[name];
  return handler ? handler(value) : value;
};

const ACTION_HANDLERS = {
  FORM_VALIDATION_ONBLUR: (state, action) => dotProp.set(state, `${action.payload.formname}.validation`, action.payload.validationfuncOnBlur(state, action.payload.name)),
  FORM_UPDATE: (state, action) => {
    let newState = dotProp.set(state, 'currentForm', `${action.payload.formname}`);
    const newValue = translationfunc(action.payload.translactionhandlers, action.payload.name, action.payload.value);
    if (dotProp.get(newState, action.payload.formname) === undefined) {
      newState = dotProp.set(newState, action.payload.formname, {});
    }
    newState = dotProp.set(newState, `${action.payload.formname}.${action.payload.name}`, newValue);
    newState = dotProp.set(newState, `${action.payload.formname}.validation`, action.payload.validationfunc(newState, action.payload.name));
    return newState;
  },
  FORM_CHECKBOX_UPDATE: (state, action) => {
    let newState = dotProp.set(state, 'currentForm', `${action.payload.formname}`);
    const newValue = action.payload.checked;
    if (dotProp.get(newState, action.payload.formname) === undefined) {
      newState = dotProp.set(newState, action.payload.formname, {});
    }
    if (dotProp.get(newState, `${action.payload.formname}.${action.payload.name}`) === undefined) {
      newState = dotProp.set(newState, `${action.payload.formname}.${action.payload.name}`, {});
    }
    newState = dotProp.set(newState, `${action.payload.formname}.${action.payload.name}.${action.payload.value}`, newValue);
    newState = dotProp.set(newState, `${action.payload.formname}.validation`, action.payload.validationfunc(newState, action.payload.value));
    return newState;
  },
  FORM_CHECKBOX_ACTIVE_ALL: (state, action) => {
    let newState = dotProp.set(state, 'currentForm', `${action.payload.formname}`);
    const newValue = true;
    if (dotProp.get(newState, action.payload.formname) === undefined) {
      newState = dotProp.set(newState, action.payload.formname, {});
    }
    if (dotProp.get(newState, `${action.payload.formname}.${action.payload.name}`) === undefined) {
      newState = dotProp.set(newState, `${action.payload.formname}.${action.payload.name}`, {});
    }
    action.payload.value.forEach((valueElement) => {
      newState = dotProp.set(newState, `${action.payload.formname}.${action.payload.name}.${valueElement}`, newValue);
      newState = dotProp.set(newState, `${action.payload.formname}.validation`, action.payload.validationfunc(newState, valueElement));
    });

    return newState;
  },
  RESET_FORM: (state, action) => {
    let newState = dotProp.set(state, 'currentForm', `${action.payload.formname}`);
    newState = dotProp.set(newState, 'temporaryValue', {});

    if (action.payload.fieldname) {
      return dotProp.set(newState, `${action.payload.formname}.${action.payload.fieldname}`, '');
    }
    return dotProp.set(newState, action.payload.formname, {});
  },
  FORM_ERROR_INVALIDATE: (state, action) => {
    let newState = state;
    const cleanValidation = (item, key) => (key === 'isValid' ? false : ' ');
    const cleanItems = (item, key) => {
      if (key === 'validation') {
        const newValid = mapObjIndexed(cleanValidation, item);
        newValid.serverError = action.payload.message;
        return newValid;
      }
      return '';
    };
    newState = dotProp.set(newState, `${state.currentForm}`, mapObjIndexed(cleanItems, state[state.currentForm]));
    return newState;
  },
  FORM_ERROR: (state, action) => { // same as FORM_ERROR_INVALIDATE but without field clearing
    let newState = state;
    const cleanValidation = (item, key) => (key === 'isValid' ? false : ' ');
    const cleanItems = (item, key) => {
      if (key === 'validation') {
        const newValid = mapObjIndexed(cleanValidation, item);
        if (action.payload.field !== undefined) {
          newValid[action.payload.field] = action.payload.message;
        } else {
          newValid.serverError = action.payload.message;
        }
        return newValid;
      }
      return item;
    };
    newState = dotProp.set(newState, `${state.currentForm}`, mapObjIndexed(cleanItems, state[state.currentForm]));
    return newState;
  },
  FORM_BACKEND_ERROR: (state, action) => {
    let newState = state;
    forEachObjIndexed((item, key) => {
      newState = dotProp.set(state, `${state.currentForm}.validation.${key}`, item);
      return true;
    }, action.payload.fieldErrors);
    newState = dotProp.set(newState, `${state.currentForm}.validation.isValid`, false);
    return newState;
  },
  FORM_FIELD_ERROR: (state, action) => {
    const newValue = action.payload.message ? action.payload.message : false;
    return dotProp.set(state, `${action.payload.formname}.validation.${action.payload.fieldname}`, newValue);
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { temporaryValue: {} };
export default function formsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
